<div class="d-flex gap-10">
  <!-- Ask -->
  <ng-container *ngIf="type != 'SUP' || (type === 'SUP' && !resendQuestion)">
    <span (click)="toggleAsk()">
     <!--  <i class="fa" [popover]="askQuestion?'Question WILL BE asked in Direct Share Link':'Question WILL NOT be asked in Direct Share Link'"
      triggers="mouseenter:mouseleave" [ngClass]="{'yes fa-question-circle-o': askQuestion, 'fa-check no': !askQuestion}"></i> -->
      <div *ngIf="!askQuestion" class="hinted" [ngClass]="{'cursor-initial': disabled}">
        <i class="fa fa-check no"></i>
        <div class="hint">Question WILL NOT be asked in Direct Share Link</div>
      </div>

      <div class="hinted" *ngIf="askQuestion" [ngClass]="{'cursor-initial': disabled}">
        <span class="custom-tag">Ask</span>
        <div class="hint">Question WILL BE asked in Direct Share Link</div>
      </div>
    </span>
  </ng-container>

  <!-- Resend -->
  <ng-container *ngIf="type === 'SUP' && askQuestion">
    <span (click)="toggleResend()">
      <div *ngIf="resendQuestion" class="hinted" [ngClass]="{'cursor-initial': disabled}">
        <i class="fa fa-check no"></i>
        <div class="hint">Question WILL NOT be resend in Direct Share Link</div>
      </div>

      <div class="hinted" *ngIf="!resendQuestion" [ngClass]="{'cursor-initial': disabled}">
        <span class="custom-tag">Resend</span>
        <div class="hint">Question WILL BE resend in Direct Share Link</div>
      </div>
    </span>
  </ng-container>
</div>
